import { render, staticRenderFns } from "./ClaimExpanse.vue?vue&type=template&id=f0fcd326&scoped=true&"
import script from "./ClaimExpanse.vue?vue&type=script&lang=js&"
export * from "./ClaimExpanse.vue?vue&type=script&lang=js&"
import style0 from "./ClaimExpanse.vue?vue&type=style&index=0&id=f0fcd326&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0fcd326",
  null
  
)

export default component.exports